import { clearModifiedValues } from './clear-modified-values';
import { getFieldIdsFailingValidation } from './get-field-ids-failing-validation';
import { getFieldValues } from './get-field-values';
import { getVisibleFieldValues } from './get-visible-field-values';
import { setFieldCustomErrors } from './set-field-custom-errors';
import { setFormRendererProps } from './set-form-renderer-props';
import { updateModifiedValue } from './update-modified-value';

export const actions: {
	clearModifiedValues: () => import('react-sweet-state').Action<
		import('../types').FormRendererState
	>;
	getFieldIdsFailingValidation: (
		validationTargets?: import('../../..').ValidationTargets,
		formFields?: import('../../..').FormFields,
		createAnalyticsEvent?: import('@atlaskit/analytics-next/types').CreateUIAnalyticsEvent,
	) => import('react-sweet-state').Action<
		import('../types').FormRendererState,
		void,
		import('../../..').FieldId[]
	>;
	getVisibleFieldValues: () => import('react-sweet-state').Action<
		import('../types').FormRendererState,
		void,
		import('../../../common/types/form/form-fields/field-values').FieldValuesPartial
	>;
	getFieldValues: () => import('react-sweet-state').Action<
		import('../types').FormRendererState,
		void,
		import('../../..').FieldValues
	>;
	setFieldCustomErrors: (
		fieldCustomErrors: import('../../..').FieldCustomErrors,
	) => import('react-sweet-state').Action<import('../types').FormRendererState>;
	setFormRendererProps: (
		asyncFields: import('../../..').AsyncFields,
		form: import('../../..').Form,
		lifecycleHandlers: import('../../..').LifecycleHandlers,
		renderers: import('../../..').Renderers,
		renderMode: import('../../..').FormRenderMode,
		fieldVisibility: import('../../../common/types/form').FormFieldVisibility,
		fieldValidation: import('../../..').FieldValidation,
		defaultValidators: import('../../..').Validators,
		attachmentConfiguration?: import('../../..').AttachmentConfiguration,
	) => import('react-sweet-state').Action<import('../types').FormRendererState>;
	updateModifiedValue: (
		fieldId: import('../../..').FieldId,
		modifiedFieldValue: import('../../../common/types/form/form-fields/field-values').ModifiedFieldValue,
	) => import('react-sweet-state').Action<import('../types').FormRendererState>;
} = {
	clearModifiedValues,
	getFieldIdsFailingValidation,
	getVisibleFieldValues,
	getFieldValues,
	setFieldCustomErrors,
	setFormRendererProps,
	updateModifiedValue,
};
